import React from "react";
import PlainEditor from "../../../../../../../merchant/panel/scripts/shared/editor/plainEditor.js";
import "./style.css";
import { useContentDt } from "../../scripts/useContentDt.js";
import { DTConfigInGalleryContext } from "../../scripts/DTConfigInGalleryContext.js";
export default function MerchantInfo(props) {
    const text = useContentDt(props.text, DTConfigInGalleryContext);
    return (React.createElement("section", { className: "merchant-info-section" },
        React.createElement(PlainEditor, { label: "", update: text, example: text, onChange: () => { }, editable: false })));
}
